import { TextInput } from "pepsico-ds";

const TextInputFieldArray = ({ value, updateValue, label, disabled }) => {
  const handleInputChange = (index, val) => {
    const newValue = value?.length ? [...value] : [];
    const values = [...newValue];
    values[index] = val;
    updateValue(values);
  };
  const safeValue = Array.isArray(value) ? value : [];

  return (
    <div>
      <span className="label-text $font-xsmall-regular">
        <label htmlFor="codes">{label}</label>
      </span>
      {safeValue.map((field, index) => (
        <div key={index}>
          <TextInput
            type="text"
            value={field}
            onUpdate={(val) => handleInputChange(index, val)}
            disabled={disabled}
          />
        </div>
      ))}
    </div>
  );
};

export default TextInputFieldArray;
